export default __webpack_public_path__ + "static/media/left.75383913.svg";